<template>
  <div>
    <ul class="nav nav-tabs" style="margin-left: 28px" role="tablist">
      <li class="nav-item">
        <h5 class="nav-link" :class="{active: activeTab === 'metrics',show: activeTab === 'metrics'}"
            @click="switchTabs('metrics')">
          {{searchType}} <span v-if="metrics.results && metrics.results.length"
                           class="badge badge-primary ml-1">{{metrics.results.length}}</span>
        </h5>
      </li>
      <li class="nav-item">
        <h5 class="nav-link" :class="{active: activeTab === 'performance',show: activeTab === 'performance'}"
            @click="switchTabs('performance')">
          {{searchType.slice(0, -1)}} Performance <span v-if="performance && performance.length"
                                      class="badge badge-primary ml-1">{{performance.length}}</span>
        </h5>
      </li>
      <li class="nav-item">
        <h5 class="nav-link" :class="{active: activeTab === 'attributes',show: activeTab === 'attributes'}"
            @click="switchTabs('attributes')">
          Top Attributes <span v-if="attributes && attributes.length"
                               class="badge badge-primary ml-1">{{attributes.length}}</span>
        </h5>
      </li>
      <li class="nav-item">
        <h5 class="nav-link" :class="{active: activeTab === 'tendencies',show: activeTab === 'tendencies'}"
            @click="switchTabs('tendencies')">
          Creative & Olfactive Tendencies <span v-if="tendencies.table_data && tendencies.table_data.length "
                                                class="badge badge-primary ml-1">{{tendencies.table_data.length}}</span>
        </h5>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane tall-pane" :class="{active: activeTab === 'metrics',show: activeTab === 'metrics'}">
        <Loader :show="!ready.metrics" :fixed="false" style="z-index: 5"/>
        <FragranceMetricsTable
          v-if="metrics.results && metrics.results.length"
          :reverse="false"
          :fields="fields"
          :download="download"
          :data="metrics.results"
          :summary="metrics.summary"
          :ready="ready"
          @update:ready="ready = $event"
          :searchType="searchType"
          :filter-fields="parsedFilterFields"
          :is-genisys="isGenisys"
        ></FragranceMetricsTable>
      </div>
      <div class="tab-pane tall-pane no-overflow"
           :class="{active: activeTab === 'performance',show: activeTab === 'performance'}">
        <Loader :show="!ready.performance" :fixed="false" style="z-index: 5"/>
        <FragrancePerformanceTable
          v-if="performance"
          :download="download"
          :data="!!performance.length ? performance : [performance]"
          :fragrances="!!(metrics.results && metrics.results.length) ? metrics.results : [metrics.results]"
          :ready="ready"
          @update:ready="ready = $event"
          :filter-fields="parsedFilterFields"
          :searchData="searchData"
          :parseSearchData="parseData"
          ref="performance-chart"
        ></FragrancePerformanceTable>
      </div>
      <div class="tab-pane tall-pane"
           :class="{active: activeTab === 'attributes',show: activeTab === 'attributes'}">
        <Loader :show="!ready.attributes" :fixed="false" style="z-index: 5"/>
        <TopAttributesTable
          v-if="attributes"
          :download="download"
          :data="!!attributes.length ? attributes : [attributes]"
          :fragrances="!!(metrics.results && metrics.results.length) ? metrics.results : [metrics.results]"
          :ready="ready"
          @update:ready="ready = $event"
          :filter-fields="parsedFilterFields"
          :searchData="searchData"
          :parseSearchData="parseData"
          ref="top-attributes-chart"
        ></TopAttributesTable>
      </div>
      <div class="tab-pane tall-pane no-overflow"
           :class="{active: activeTab === 'tendencies',show: activeTab === 'tendencies'}">
        <Loader :show="!ready.tendencies" :fixed="false" style="z-index: 5"/>
        <TendenciesTable
          v-if="tendencies"
          :download="download"
          :data="!!tendencies.table_data && tendencies.table_data.length ? tendencies.table_data : []"
          :ready="ready"
          @update:ready="ready = $event"
          :fragrances="!!(metrics.results && metrics.results.length) ? metrics.results : [metrics.results]"
          :filter-fields="parsedFilterFields"
          :searchData="searchData"
          :parseSearchData="parseData"
          ref="tendencies-chart"
        ></TendenciesTable>
      </div>
    </div>
  </div>
</template>

<script>
import FragranceMetricsTable from './Tables/FragranceMetricsTable'
import FragrancePerformanceTable from './Tables/FragrancePerformanceTable'
import TopAttributesTable from './Tables/TopAttributesTable'
import TendenciesTable from './Tables/TendenciesTable'
import { mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import Loader from '../shared/Loader'

export default {
  name: 'AnalyticsTabs',
  components: { Loader, TendenciesTable, TopAttributesTable, FragrancePerformanceTable, FragranceMetricsTable },
  props: {
    switchTabs: Function,
    filterFields: Array,
    activeTab: String,
    searchData: Function,
    searchType: String,
    download: Function,
    parseData: Function,
    fields: Array,
    collapsed: Boolean,
    isGenisys: Boolean
  },
  data () {
    return {
      ready: {
        metrics: false,
        performance: true,
        attributes: true,
        tendencies: true
      }
    }
  },
  mounted () {
    const results = this.metrics && this.metrics.results ? this.metrics.results : []
    if (Array.isArray(results) ? results.length : Object.keys(results || {}).length) {
      this.ready.metrics = true
    }
  },
  computed: {
    ...mapGetters({
      metrics: studiesGetters.GET_ANALYTICS,
      performance: studiesGetters.GET_ANALYTICS_PROFILE,
      tendencies: studiesGetters.GET_ANALYTICS_TENDENCIES,
      attributes: studiesGetters.GET_ANALYTICS_ATTRIBUTES
    }),
    parsedFilterFields () {
      const results = {}
      if (Array.isArray(this.filterFields) && this.filterFields.length) {
        const aggregation = this.filterFields.find(el => el.group_label === 'aggregation')
        const metricsRange = this.filterFields.find(el => el.group_label === 'metrics_range')
        const tendenciesMetadata = this.filterFields.find(el => el.group_label === 'tendencies_metadata')
        const attributesMetadata = this.filterFields.find(el => el.group_label === 'attributes_metadata')
        const aggregationMetadata = this.filterFields.find(el => el.group_label === 'aggregation_metadata')
        if (aggregation && aggregation.data) results.demographics = aggregation.data.demographics || {}
        if (metricsRange && metricsRange.data) results.metrics_range = metricsRange.data
        if (tendenciesMetadata && tendenciesMetadata.data) results.tendencies_metadata = tendenciesMetadata.data
        if (attributesMetadata && attributesMetadata.data) results.attributes_metadata = attributesMetadata.data
        if (aggregationMetadata && aggregationMetadata.data) results.aggregation_metadata = aggregationMetadata.data
      }
      return results
    }
  },
  methods: {
    resetTabs () {
      const tableRefs = Object.keys(this.$refs).filter(el => el.includes('chart'))
      tableRefs.forEach(el => {
        this.$refs[el].searchExecuted = false
      })
      this.ready = {
        metrics: false,
        performance: true,
        attributes: true,
        tendencies: true
      }
    }
  },
  watch: {
    performance (data) {
      this.ready.performance = true
    },
    tendencies (data) {
      const tableData = data && data.table_data ? data.table_data : []
      this.ready.tendencies = Array.isArray(tableData) && tableData.length > 0
    },
    attributes (data) {
      this.ready.attributes = true
    },
    metrics (data) {
      const results = data && data.results ? data.results : []
      this.ready.metrics = Array.isArray(results)
        ? results.length > 0
        : Object.keys(results || {}).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import url('https://fonts.googleapis.com/css?family=Lato&display=swap');

.tab-pane {
  min-height: 555px;
  overflow: unset;
}

.nav-link {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;

  &:hover {
    border-bottom-color: $charcoal !important;
  }

  &.active {
    position: relative;

    &:hover {
      border-bottom-color: transparent !important;
    }

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      width: 80%;
      left: 10%; /*this centers it based on the above width*/
      border-bottom: 2px solid $dusty-blue;
    }
  }
}

.badge {
  border-radius: 2px;
  background-color: $blueberry !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
}

.tab-content {
  border: 1px solid $charcoal;
  border-left: 0;
  border-right: 0;
}

.open-filter-button {
  position: absolute;
  top: 24px;
  right: 24px;
  font-size: 35px;
  line-height: 35px;
  height: 35px;
  color: $home-card;
  cursor: pointer;
  transition: color 0.2s linear;

  &:hover {
    color: $navbar-dropdown-text
  }
}
</style>
